import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
} from '@mui/material';

function CoordinatorWiseSummaryModal(props) {
  const { open, onClose, data = [], loading = false } = props;

  const formatAmount = (v) => {
    const n = parseFloat(v || 0);
    return `₹${n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>Coordinator Wise Summary</DialogTitle>
      <DialogContent>
        {loading ? (
          <Typography>Loading...</Typography>
        ) : data.length > 0 ? (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>Coordinator</strong>
                </TableCell>
                <TableCell align="right">
                  <strong>Order Total</strong>
                </TableCell>
                <TableCell align="right">
                  <strong>Issued Invoice Total</strong>
                </TableCell>
                <TableCell align="right">
                  <strong>Invoiced</strong>
                </TableCell>
                <TableCell align="right">
                  <strong>Discount</strong>
                </TableCell>
                <TableCell align="right">
                  <strong>Paid</strong>
                </TableCell>
                <TableCell align="right">
                  <strong>Balance</strong>
                </TableCell>
                <TableCell align="right">
                  <strong>Due by Today</strong>
                </TableCell>
                <TableCell align="right">
                  <strong>Balance to Pay by Today</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, index) => (
                <TableRow key={row.coordinator_id || index}>
                  <TableCell>{row.coordinator_name || 'No Coordinator'}</TableCell>
                  <TableCell align="right">{formatAmount(row.totals.order)}</TableCell>
                  <TableCell align="right">{formatAmount(row.totals.issued)}</TableCell>
                  <TableCell align="right">{formatAmount(row.totals.invoiced)}</TableCell>
                  <TableCell align="right">{formatAmount(row.totals.discount)}</TableCell>
                  <TableCell align="right">{formatAmount(row.totals.paid)}</TableCell>
                  <TableCell align="right">{formatAmount(row.totals.balance)}</TableCell>
                  <TableCell align="right">{formatAmount(row.totals.dueByToday)}</TableCell>
                  <TableCell align="right">{formatAmount(row.totals.balanceToPayByToday)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Typography>No data available</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}

export default CoordinatorWiseSummaryModal;

